<template>
  <v-container fluid grid-list-md>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title>
            <span class="headline">Invite user to join: {{ selectedSite.name }} </span>
          </v-card-title>
          <v-card-text>
            Enter the email address of the user you wish to invite:
            <v-form v-model="formValid" ref="form">
              <v-text-field
              label="Email"
              id="email"
              required
              v-model="email"
              v-on:keyup.enter="reset()"
              :rules="rulesEmail"
              ></v-text-field>
              <v-select
              label="Role"
              :items="roles"
              v-model="role"
              item-text="name"
              item-value="value"
              :rules="rulesRole"
              ></v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined text :to="{name: 'userImport'}">Import CSV</v-btn>
            <v-spacer></v-spacer>
            <v-btn outlined class="blue--text darken-1" text @click="invite">Add User</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

  <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import { AuthMixins } from '@/shared/mixins'
import ErrorSnackbar from '@/components/ErrorSnackbar'
import Rules from '@/shared/rules'

export default {
  components: {
    ErrorSnackbar
  },

  mixins: [AuthMixins],

  data () {
    return {
      email: '',
      errorText: '',
      formValid: true,
      role: null,

      rulesEmail: [
        v => !!v || 'E-mail is a required field',
        v => Rules.email(v)
      ],
      rulesRole: [
        v => !!v || 'Role is a required field'
      ]
    }
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ])
  },

  methods: {
    invite: function () {
      this.$refs.form.validate()
      if (this.formValid) {
        var body = {
          email: this.email,
          role: this.role
        }
        ApiRequests.siteUserAdd(this.selectedSite._id, body).then(response => {
          this.errorText = 'Invitation Sent'
        }).catch(e => {
          this.errorText = 'Error: ' + e.response.data
        })
      } else {
        this.errorText = 'Please enter a valid email address'
      }
    }
  }
}
</script>
